export const en = {
    FROM_14_TO_28_DAYS: '14-28 days',
    FROM_1_TO_3_DAYS: '1-3 days',
    FROM_1_TO_3_MONTHS: 'from 1 to 3 months',
    FROM_3_TO_7_DAYS: '3-7 days',
    FROM_7_TO_14_DAYS: '7-14 days',
    MONTHLY: 'monthly',
    MORE_THAN_3_MONTHS: 'more than 3 months'
};
